import * as microsoftTeams from "@microsoft/teams-js";
import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_SELECTED_MS_TEAM', function setSelectedMSTeam(msTeamInfo: microsoftTeams.TeamInformation) {
    if (teamSetupPickerStore.teamSetupInfo) {
        teamSetupPickerStore.teamSetupInfo.msTeamInfo = msTeamInfo;
    }
});
